var firebase = require('../firebase');
var toastr = require('toastr');

var { fbDb, fbStorage } = firebase;

module.exports = {
	fetching: function() {
		return {
			type: "DATA_FETCHING"
		};
	},

	createUserSuccess: function(user) {
		return {
			type: "CREATE_USER_SUCCESS",
			payload: user
		};
	},

	loadUsersSuccess: function(users) {
		return {
			type: "LOAD_USERS_SUCCESS",
			payload: users
		};
	},

	updateUserSuccess: function(user) {
		return {
			type: "UPDATE_USER_SUCCESS",
			payload: user
		};
	},

	deleteUserSuccess: function(user) {
		return {
			type: "DELETE_USER_SUCCESS",
			payload: user
		};
	},

	filterUsers: function(type) {
		return {
			type: "FILTER_USERS",
			payload: type
		};
	},

	unloadUsers: function() {
		return {
			type: "UNLOAD_USERS"
		}
	},

	update: function(key, data) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`users/${key}`)
			.update(data, error => error ? reject(error) : resolve());
		});
	},

	remove: function(key) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`users/${key}`)
			.remove(error => error ? reject(error) : resolve());
		});
	},

	set: function(key, value) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`users/${key}`)
			.set(value, error => error ? reject(error) : resolve());
		});
	},

	unwrapUser: function(snap) {
		var user = snap.val();

		return Object.assign({
		}, user.personalData, {
			id: snap.key, status: user.status, userType: user.userType
		});
	},

	loadUsers: function() {
		var me = this;

		return function(dispatch) {
			var ref = fbDb.ref('users').orderByChild("createdAt"), 
				list = [],
				initialized = false;

			ref.once('value', (users) => {
				initialized = true;
				dispatch(me.loadUsersSuccess(list));
			});

			ref.on('child_added', snap => {
				var user = me.unwrapUser(snap);

				if (initialized)
					dispatch(me.createUserSuccess(user));
				else
					list.unshift(user);
			});

			ref.on('child_changed', snap => {
				var user = me.unwrapUser(snap);

				dispatch(me.updateUserSuccess(user));
			});

			ref.on('child_removed', snap => {
				var user = me.unwrapUser(snap);

				dispatch(me.deleteUserSuccess(user));
			});

			me._unsubscribe = () => ref.off();

			dispatch(me.fetching());
		}
	},

	unsubscribe: function() {
		var me = this;

		return function(dispatch) {
			me._unsubscribe();
			
			dispatch(me.unloadUsers());
		};
	},

	createUser: function(user) {
		var me = this;
		
		if (user.fgtype === 0) {
			return function(dispatch) {
				me.set(user.uid, {
					status: 1,
					userType: user.fgtype,
					createdAt: new Date().getTime(),
					personalData: {
						email: user.email,
						name: user.name,
						cpf: user.cpf,
						phone: user.phone
					}
				}).catch(error => console.log(error));
			};
		} else {
			return function(dispatch) {
				me.set(user.uid, {
					status: 0,
					userType: user.fgtype,
					createdAt: new Date().getTime(),
					personalData: {
						email: user.email,
						name: user.name,
						cnpj: user.cnpj,
						address: user.address,
						city: user.city,
						state: user.state,
						nickname: user.nickname,
						phone: user.phone,
						paymentDay: String(user.paymentDay),
					}
				}).catch(error => console.log(error));		
			};
		}
	},

	updateUser: function(key, data) {
		var me = this;

		return function(dispatch) {
			me.update(key, data)
			.then(() => {
				toastr.success('O usuário foi atualizado com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao atualizar o registro.');
			})
		}
	},

	removeUser: function(key) {
		var me = this;

		return function(dispatch) {
			me.remove(key)
			.then(() => {
				toastr.success('O usuário foi excluído com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao remover o registro.');
			})
		}
	}
};


// WEBPACK FOOTER //
// ./src/actions/userActions.js